import { render, staticRenderFns } from "./ClaimReviewForm.vue?vue&type=template&id=8b419d42&scoped=true"
import script from "./ClaimReviewForm.vue?vue&type=script&lang=ts"
export * from "./ClaimReviewForm.vue?vue&type=script&lang=ts"
import style0 from "./ClaimReviewForm.vue?vue&type=style&index=0&id=8b419d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b419d42",
  null
  
)

export default component.exports